import * as React from 'react'
import './Analysis.scss'
import Model, {
  UserData,
  // DefaultUserData,
  TransactionData,
  AnnotationData
} from '../../model/Model'
import Dropdown from '../Dropdown/Dropdown'
import { Metadata } from '@jibo-cloud/qas-client'

export interface AnalysisProps {
  appModel: Model;
  appName: string;
  clicked: any;
  changed: any;
  userData: UserData;
  transactionData: TransactionData;
  annotationData: AnnotationData;
  metadata: Metadata[];
}

export interface AnalysisState {
  appName: string;
  intentCategory_1: string;
  intentCategory_2: string;
  intentId_1: string;
  intentId_2: string;
  appMetadata: any;
}

export default class Analysis extends React.Component<AnalysisProps, AnalysisState> {
  constructor (props: AnalysisProps) {
    super(props)

    this.state = {
      appName: props.appName,
      intentCategory_1: '',
      intentCategory_2: '',
      intentId_1: props.transactionData.intentId,
      intentId_2: props.annotationData.intentId,
      appMetadata: (props.metadata || []).find(m => m.appName === props.appName) || {}
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps: AnalysisProps) {
    if (
      nextProps.appName !== this.state.appName ||
      nextProps.metadata !== this.props.metadata ||
      nextProps.transactionData !== this.props.transactionData ||
      nextProps.annotationData !== this.props.annotationData
    ) {
      this.setState({
        appName: nextProps.appName,
        appMetadata: (nextProps.metadata || []).find(m => m.appName === nextProps.appName) || {},
        intentId_1: nextProps.transactionData.intentId!,
        intentId_2: nextProps.annotationData.intentId!
      })
    }
  }

  onBlur = (event: any) => {};

  onChange = (event: any) => {
    const nativeEvent: any = event.nativeEvent
    const stateObject: any = {}
    const propertyName: string = nativeEvent.target.name
    stateObject[propertyName] = nativeEvent.target.value
    this.setState(stateObject)
  };

  onClick = (action: string) => {};

  onDropdownChanged = (name: string, data: any) => {
    console.log(`onDropdownChanged: ${name}`, data)
    const stateObject: any = {}
    const propertyName: string = name
    stateObject[propertyName] = data
    this.setState(stateObject, () => {
      if (propertyName === 'intentId_1') {
        console.log('propertyName: intentId_1')
      }
    })
  };

  onCheckboxChanged = (label: string, isChecked: boolean) => {};

  render () {
    const intentCategoryOptions_1: any[] = []
    let intentCategorySelected_1 = { label: '', value: '' }
    intentCategoryOptions_1.push({ label: '', value: '' })
    if (this.state.appMetadata && this.state.appMetadata.categories) {
      this.state.appMetadata.categories.forEach((category: any) => {
        const option: any = { label: ` ${category}`, value: category }
        intentCategoryOptions_1.push(option)
        if (category === this.state.intentCategory_1) {
          intentCategorySelected_1 = option
        }
      })
    }

    const intentCategoryOptions_2: any[] = []
    let intentCategorySelected_2 = { label: '', value: '' }
    intentCategoryOptions_2.push({ label: '', value: '' })
    if (this.state.appMetadata && this.state.appMetadata.categories) {
      this.state.appMetadata.categories.forEach((category: any) => {
        const option: any = { label: ` ${category}`, value: category }
        intentCategoryOptions_2.push(option)
        if (category === this.state.intentCategory_2) {
          intentCategorySelected_2 = option
        }
      })
    }

    const intentIdOptions_1: any[] = []
    let intentIdSelected_1 = { label: '', value: '' }
    let intentIdQuestion_1 = ''
    let intentIdAnswer_1 = ''
    let intentIdTraining_1 = ''
    intentIdOptions_1.push({ label: '', value: '' })
    if (this.state.appMetadata && this.state.appMetadata.intents) {
      this.state.appMetadata.intents.forEach((intent: any) => {
        const option: any = {
          label: `[${intent.intentId}: ${intent.category}]: ${intent.intentDetail}`,
          value: intent.intentId
        }
        if (!this.state.intentCategory_1 || this.state.intentCategory_1 === intent.category) {
          intentIdOptions_1.push(option)
        }
        if (intent.intentId === this.state.intentId_1) {
          intentIdSelected_1 = option
          intentIdQuestion_1 = intent.intentDetail
          if (intent.proprietary) {
            intentIdAnswer_1 = intent.proprietary.answer
            intentIdTraining_1 = intent.proprietary.questions ? intent.proprietary.questions.sort().join('\n') : ''
          }
        }
      })
    }

    const intentIdOptions_2: any[] = []
    let intentIdSelected_2 = { label: '', value: '' }
    let intentIdQuestion_2 = ''
    let intentIdAnswer_2 = ''
    let intentIdTraining_2 = ''
    intentIdOptions_2.push({ label: '', value: '' })
    if (this.state.appMetadata && this.state.appMetadata.intents) {
      this.state.appMetadata.intents.forEach((intent: any) => {
        const option: any = {
          label: `[${intent.intentId}: ${intent.category}]: ${intent.intentDetail}`,
          value: intent.intentId
        }
        if (!this.state.intentCategory_2 || this.state.intentCategory_2 === intent.category) {
          intentIdOptions_2.push(option)
        }
        if (intent.intentId === this.state.intentId_2) {
          intentIdSelected_2 = option
          intentIdQuestion_2 = intent.intentDetail
          if (intent.proprietary) {
            intentIdAnswer_2 = intent.proprietary.answer
            intentIdTraining_2 = intent.proprietary.questions ? intent.proprietary.questions.sort().join('\n') : ''
          }
        }
      })
    }

    return (
      <div id="analysisContainer">
        <label className="intentLabel">{`Intent ID: ${this.state.intentId_1}`}</label>
        <Dropdown
          name="intentCategory_1"
          options={intentCategoryOptions_1}
          selectedOption={intentCategorySelected_1}
          changed={this.onDropdownChanged}
        />
        <Dropdown
          name="intentId_1"
          options={intentIdOptions_1}
          selectedOption={intentIdSelected_1}
          changed={this.onDropdownChanged}
        />

        <textarea id="intentId_1_question" className="intentQuestion" value={intentIdQuestion_1} readOnly />
        <textarea id="intentId_1_answer" className="intentAnswer" value={intentIdAnswer_1} readOnly />
        <textarea id="intentId_1_training" className="intentTraining" value={intentIdTraining_1} readOnly />

        <label className="intentLabel">{`Intent ID: ${this.state.intentId_2}`}</label>
        <Dropdown
          name="intentCategory_2"
          options={intentCategoryOptions_2}
          selectedOption={intentCategorySelected_2}
          changed={this.onDropdownChanged}
        />
        <Dropdown
          name="intentId_2"
          options={intentIdOptions_2}
          selectedOption={intentIdSelected_2}
          changed={this.onDropdownChanged}
        />

        <textarea id="intentId_2_question" className="intentQuestion" value={intentIdQuestion_2} readOnly />
        <textarea id="intentId_2_answer" className="intentAnswer" value={intentIdAnswer_2} readOnly />
        <textarea id="intentId_2_training" className="intentTraining" value={intentIdTraining_2} readOnly />
      </div>
    )
  }
}
